// extracted by mini-css-extract-plugin
module.exports = {"footerButtons":"FooterButtons_footerButtons__3xVAw","divider":"FooterButtons_divider__2kUZ9","buttons":"FooterButtons_buttons__x64hp"};